import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Lightbox } from "ngx-lightbox/lightbox.service";
import {
  c1,
  c3,
  c4,
  c5,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Menu, MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";

@Component({
  selector: "app-gen-appbar-component",
  templateUrl: "./gen-appbar-component.component.html",
  styleUrls: ["./gen-appbar-component.component.scss"],
})
export class GenAppbarComponentComponent implements OnInit, OnDestroy {
  constructor(
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService
  ) {}

  @Input() page_id: string;
  @Input() tabData: Tab;

  page: any;
  c4_value: string;
  c5_value: string;
  c3_value: string;
  offCanvasSubscription: any;
  albums = [];
  title: string;
  offcanvasColors = offcanvasColors;
  enableNav: boolean;
  singleTab: string = c3.SINGLE;
  modalRef?: BsModalRef;
  nextTab: Tab;
  menu: Menu;
  appHome: any = { id: "home", app: { tabs: [] } };
  chatId: string;
  menuId: string;

  ngOnInit() {
    this.albums = [
      {
        id: c5.WIDE,
        src: "../../../assets/images/small/img-3-anavtab.jpg",
        caption: " Icon and Title",
      },
      {
        id: c5.STANDARD,
        src: "../../../assets/images/small/img-4-anavtab.jpg",
        caption: "Icon or Title",
      },
    ];

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "gen" &&
          data.page.id == this.page_id
        ) {
          const appHome = this.indexDBService.getItem("app", "home");
          appHome.onsuccess = (event) => {
            if (appHome.result) {
              this.appHome = appHome.result;
              // active_title_icon_color  (new)
              if (
                this.appHome.app &&
                this.appHome.app.appbar &&
                this.appHome.app.appbar.menu_id
              ) {
                const menu = this.indexDBService.getItem(
                  "menu",
                  this.appHome['app']["appbar"].menu_id
                );
                menu.onsuccess = (event) => {
                  if (menu.result) {
                    this.menu = menu.result;
                    this.menuId = menu.result.menu_id;
                    const tab = this.indexDBService.getItem(
                      "tab",
                      menu.result.menu_group
                    );
                    tab.onsuccess = (event) => {
                      if (tab.result) {
                        this.nextTab = { ...tab.result };
                      }
                    };
                  }
                };
              }
            }
          };
        }
      }
    );
  }
  open(index: number): void {
    // open lightbox
    this.c5_value = this.albums[index].id;
    let modes = [{ id: c5.ID, value: this.c5_value }];
    this.mdw.changeMobileTheme(modes);
    this.mdw.changeTab(
      { tab: this.tabData },
      localStorage.getItem("mode"),
      true
    );
  }

  onSelectScreen(event) {
    this.chatId = event.data.menu_id;
    this.appHome["app"]["appbar"]["menu_id"] = this.chatId;
    const menu = this.indexDBService.getItem("menu", this.chatId);
    menu.onsuccess = (event) => {
      if (menu.result) {
        // console.log(menu.result);
        this.menu = menu.result;
        this.menuId = menu.result.menu_id;
        const tab = this.indexDBService.getItem("tab", menu.result.menu_group);
        tab.onsuccess = (event) => {
          if (tab.result) {
            this.nextTab = { ...tab.result };
          }
        };
      }
    };
    this.indexDBService.updateItem("app", this.appHome);
    this.mdw.changeTab(  { tab: this.tabData },   localStorage.getItem("mode"),    true  );
    this.mdw._appbarContainer.next({isAppbar:true, cat:"home", menu_id:this.chatId})
    this.modalRef.hide();
  }

  deleteTab() {
    delete this.appHome["app"]["appbar"]["menu_id"];
    this.nextTab = null;
    this.indexDBService.updateItem("app", this.appHome);
    this.mdw.changeTab( { tab: this.tabData },  localStorage.getItem("mode"),   true  );

    this.mdw._appbarContainer.next({appbar:false, cat:"home", menu_id:null})
  }

  openUsersSelector(changeRoll) {
    this.modalRef = this.modalService.show(changeRoll, {
      class: "modal-xl modal-dialog-centered",
    });
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
  }
}
